
import * as React from "react";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface DataLoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "default" | "sm" | "lg";
  text?: string;
  fullPage?: boolean;
}

const DataLoading = React.forwardRef<HTMLDivElement, DataLoadingProps>(
  ({ className, size = "default", text = "Loading data...", fullPage = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center",
          fullPage ? "min-h-[50vh]" : "py-8",
          className
        )}
        {...props}
      >
        <Loader2 
          className={cn(
            "animate-spin text-primary",
            size === "sm" ? "h-4 w-4" : size === "lg" ? "h-10 w-10" : "h-6 w-6"
          )} 
        />
        {text && (
          <p className={cn(
            "text-muted-foreground mt-2",
            size === "sm" ? "text-xs" : size === "lg" ? "text-base" : "text-sm"
          )}>
            {text}
          </p>
        )}
      </div>
    );
  }
);

DataLoading.displayName = "DataLoading";

export { DataLoading };
